import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-screen sm:h-[58px] h-[77px] border bg-h-primary-50 flex items-center mx-auto min-h-full overflow-x-visible custom-breadcrumb-options" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_Breadcrumb, {
      home: _ctx.home,
      model: _ctx.items,
      class: "w-screen !pl-[3vw] !text-base !leading-5 custom-breadcrumb !text-neutral-900"
    }, {
      item: _withCtx(({ item }) => [
        _createElementVNode("span", {
          onClick: item?.command,
          class: _normalizeClass(`${item?.command
                    ? 'cursor-pointer hover:text-h-secondary-700 transition-all font-bold'
                    : 'cursor-default'
                    } capitalize break-all line-clamp-1 max-w-[900px]`)
        }, _toDisplayString(item.label), 11, _hoisted_2)
      ]),
      _: 1
    }, 8, ["home", "model"])
  ]))
}